import React, { FC } from 'react';
import classnames from 'classnames';
import { FieldArray, FormikActions, FormikState, getIn } from 'formik';
import { useDragAndDrop } from '@formkit/drag-and-drop/react';

import styles from './reorderFormStyles.scss';

const ReorderForm: FC<{
  attr: string;
  isSubmitting: FormikState<any>['isSubmitting'];
  renderItem: FC<{ props: any }>;
  setFieldValue: FormikActions<any>['setFieldValue'];
  values: any[];
}> = ({ attr, isSubmitting, renderItem, setFieldValue, values }) => {
  const list = getIn(values, attr);
  const config = { onDragend: (eventData: any): void => setFieldValue(attr, eventData.values) };
  const [parent, draggableList] = useDragAndDrop<HTMLUListElement, any>(list, config);

  return (
    <FieldArray name={attr}>
      {() => (
        <ul
          className={classnames(styles.sortableList, { [styles.disabled]: isSubmitting })}
          ref={parent}
        >
          {draggableList.map((item, idx) => (
            <li key={idx}>{renderItem(item)}</li>
          ))}
        </ul>
      )}
    </FieldArray>
  );
};

export default ReorderForm;
